import httpService from "./htttp.service";

class UserService {


  async getUserByEmail(email) {
    try {
      const response = await httpService.get(`users/${email}`);
      return response;
    } catch (error) {
      console.error("Error fetching user:", error);
      throw error;
    }
  }

  async updateUser(userId, userData) {
    try {
      const response = await httpService.put(`users/${userId}`, userData);
      return response;
    } catch (error) {
      console.error("Error updating user:", error);
      throw error;
    }
  }
}

const userService = new UserService();
export default userService;